<template>
  <v-container id="taxslabs" fluid tag="section">
    <div class="text-right">
      <v-btn color="cyan" @click="showFilter = !showFilter" small>
        <v-icon>mdi-filter</v-icon>
      </v-btn>
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" color="secondary" small>
            <h3>
              {{ $i18n.t("Action") }}
              <v-icon>mdi-menu-down</v-icon>
            </h3>
          </v-btn>
        </template>
        <v-list>
          <v-list-item :to="'/settings/template/create'">
            <v-list-item-title>{{ $i18n.t("Create") }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>

    <v-row justify="center" v-if="showFilter">
      <v-col cols="12" md="12">
        <base-material-card
          color="cyan"
          icon="mdi-filter"
          class="px-3 py-1 small-icon"
          v-if="showFilter"
        >
          <div class="filter-close">
            <v-btn
              color="black"
              class="mr-0"
              fab
              small
              text
              @click="showFilter = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
          <v-row>
            <v-col cols="12" md="2">
              <v-text-field
                :label="$i18n.t('Name')"
                class="purple-input"
                v-model="filters.name"
              />
            </v-col>
            <v-col cols="12" md="2">
              <v-select
                :items="kinds"
                item-text="name"
                item-value="value"
                :label="$i18n.t('Kind')"
                class="purple-input"
                v-model="filters.kind"
              />
            </v-col>

            <v-col cols="12" md="2" class="text-right">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="mr-0"
                    color="grey darken"
                    fab
                    text
                    small
                    @click="clear(1)"
                    style="margin-right:10px !important"
                    v-on="on"
                  >
                    <v-icon>mdi-cached</v-icon>
                  </v-btn>
                </template>
                <span>{{ $i18n.t("Clear Filter") }}</span>
              </v-tooltip>
              <v-btn
                color="success"
                class="mr-0"
                fab
                small
                dark
                @click="search()"
                :loading="loading"
              >
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </base-material-card>
      </v-col>
    </v-row>

    <v-btn
      v-if="grid != undefined && !grid.records"
      class="text-center secondary--text pa-10"
      text
      color="primary"
      style="width:100%"
      :loading="loading"
      >{{ $i18n.t("No records available") }}</v-btn
    >

    <base-material-card
      icon="mdi-domain"
      :title="$i18n.t('Templates')"
      class="px-5 py-3 small-icon"
      v-if="grid.records"
      color="primary"
    >
      <z-grid-record :grid="grid" />
      <v-simple-table>
        <thead>
          <tr>
            <th class="primary--text">{{ $i18n.t("Name") }}</th>
            <th class="primary--text">{{ $i18n.t("Kind") }}</th>
            <th class="primary--text">{{ $i18n.t("Download/Upload") }}</th>
            <th class="primary--text">{{ $i18n.t("Sample File") }}</th>
            <th class="primary--text">{{ $i18n.t("Default") }}</th>
            <th class="text-right primary--text">{{ $i18n.t("Action") }}</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="bu in grid.rows" :key="bu._id">
            <td>{{ bu.name }}</td>
            <td>{{ bu.kindStr }}</td>
            <td>
              <v-icon v-if="bu.forUpload" color="success">mdi-upload</v-icon>
              <v-icon v-if="!bu.forUpload" color="blue">mdi-download</v-icon>
            </td>
            <td>
              <a
                style="cursor:pointer;"
                :href="'/api/template/' + bu._id + '/sample'"
                v-if="bu.forUpload"
              >
                <v-icon>mdi-cloud-download</v-icon>
              </a>
            </td>
            <td>
              <v-btn color="success" x-small fab dark text v-if="!bu.corp_id">
                <v-icon>mdi-check</v-icon>
              </v-btn>
              <!-- <v-icon v-if="bu.corp_id">mdi-close</v-icon> -->
            </td>
            <td>
              <z-confirm-button
                v-if="bu.corp_id"
                class="float-right"
                color="red lighten-1"
                small
                fab
                text
                dark
                :message="$i18n.t('Do you want to delete this template ?')"
                @click="deletebu(bu)"
              >
                <v-icon>mdi-trash-can-outline</v-icon>
              </z-confirm-button>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-if="bu.corp_id"
                    class="float-right"
                    color="primary"
                    small
                    fab
                    text
                    dark
                    :to="'/settings/template/' + bu._id"
                    v-on="on"
                  >
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>Edit</span>
              </v-tooltip>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
      <v-container>
        <v-row justify="center">
          <v-col cols="8">
            <v-container class="max-width">
              <v-pagination
                v-model="grid.page"
                class="my-4"
                :length="grid.total"
                total-visible="10"
                @input="showPage"
              ></v-pagination>
            </v-container>
          </v-col>
        </v-row>
      </v-container>
    </base-material-card>
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component
export default class TaxSlabs extends Vue {
  grid = { page: 0 };
  rows = 20;
  url = "/api/template/grid?rows=" + this.rows;
  showFilter = false;
  name = "";
  menu1 = false;
  filterUrl = "";
  country = "";
  city = "";
  on = null;
  page = 1;
  filters = { name: null };
  kinds = [
    { value: 1, name: "Trip" },
    { value: 2, name: "Invoice" },
    { value: 3, name: "Employee" },
    { value: 4, name: "Vehicle" },
    { value: 5, name: "Invoice Print" },
    { value: 6, name: "Client" },
    { value: 7, name: "Vendor" },
  ];

  get loading() {
    return common.loading;
  }

  async mounted() {
    common.setLoading(true);
    try {
      this.grid = await doGet(this.url);
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }

  async showPage(page) {
    this.page = page;
    this.grid = await doGet(this.url + this.filterUrl + "&page=" + page);
    common.setLoading(false);
  }

  async clear() {
    this.filters = {};
    this.page = 1;
    this.search();
  }

  async search() {
    this.filterUrl = "";
    if (this.filters.name) this.filterUrl += "&name=" + this.filters.name;
    common.setLoading(true);
    await this.showPage(1);
  }

  async deletebu(bu) {
    common.setLoading(true);
    try {
      await doGet("/api/template/" + bu._id + "/delete");
      common.showMessage("Deleted Successfully");
      await this.search();
      common.setLoading(false);
    } catch (e) {
      common.setError(e.message);
      common.setLoading(false);
    }
  }
}
</script>

<style scoped>
.filter-close {
  position: absolute;
  right: 5px;
  top: 5px;
}
.dialog {
  position: fixed;
  top: 100px;
  width: 60%;
  z-index: 10;
  margin-left: 15%;
}
.btn-list-item {
  padding: 0;
  float: left !important;
}
.btn-list-item .v-btn--text {
  padding: 0;
  text-transform: none;
  font-size: 14px;
  float: left;
  margin: 0;
}
</style>
